import { useState } from "react";
import { Printer, Loader2 } from "lucide-react";
import adminApi from "@/lib/adminApi";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const pad = (n) => String(n).padStart(2, "0");
const mondayYmd = (offsetWeeks) => {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7) + 7 * offsetWeeks);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// v2.8+E347 · one-tap PDF of next (or this) week's schedule.
export const WeekSchedulePdfButtons = () => {
  const [busy, setBusy] = useState(null);
  const download = async (offset) => {
    setBusy(offset);
    try {
      const week = mondayYmd(offset);
      const res = await adminApi.get("/admin/schedule/week.pdf", { params: { week_start: week }, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `schedule_week_of_${week}.pdf`; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      toast.success("Schedule PDF downloaded");
    } catch (_e) {
      toast.error("Could not create the schedule PDF");
    } finally { setBusy(null); }
  };
  return (
    <div className="flex items-center gap-2">
      <Button size="sm" onClick={() => download(1)} disabled={busy !== null} data-testid="schedule-pdf-next-week" className="h-9 text-xs bg-zinc-900 hover:bg-zinc-800 text-white dark:bg-zinc-100 dark:text-zinc-900">
        {busy === 1 ? <Loader2 className="h-3.5 w-3.5 animate-spin mr-1"/> : <Printer className="h-3.5 w-3.5 mr-1"/>}Next week PDF
      </Button>
      <Button size="sm" variant="ghost" onClick={() => download(0)} disabled={busy !== null} data-testid="schedule-pdf-this-week" className="h-9 text-xs text-zinc-500">
        {busy === 0 ? <Loader2 className="h-3.5 w-3.5 animate-spin mr-1"/> : null}This week
      </Button>
    </div>
  );
};

export default WeekSchedulePdfButtons;
